export default "__VITE_ASSET__RpneoKZe__"